// import { Sketches as View } from 'ui-components';

// import { useSetActive } from '~map-view/states/sketch';
export const SketchView = (props) => {
	// const setActive = useSetActive();
	if (props.active === "Sketch View") return <div>Sketch View</div>;
	return null;
};
